import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

class SelectInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      input,
      label,
      meta: { error, touched, warning },
      options,
      hintText,
      disabled,
    } = this.props;
    return (
      (!options || !options.length) ? <div /> :
      <SelectField
        {...input}
        hintText={hintText}
        ref={(s) => { this.select = s; }}
        floatingLabelText={label}
        errorText={touched && (error || warning)}
        onChange={(e, i, v) => input.onChange(v, i, v)}
        onBlur={() => null}
        value={input.value}
        fullWidth
        disabled={disabled}
      >
        {options.map((o, i) =>
          <MenuItem value={o.value} primaryText={o.label} key={i} />)}
      </SelectField>
    );
  }
}

SelectInput.defaultProps = {
  hintText: '',
  label: '',
};

SelectInput.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  label: PropTypes.node,
  options: PropTypes.array.isRequired,
  hintText: PropTypes.node,
  disabled: PropTypes.bool,
};

export default SelectInput;



// WEBPACK FOOTER //
// ./src/components/form/SelectInput.js